<template>
  <div>
    <br />
    <br />
    <h3>
      Not Verified Yet
      <v-btn small @click="$emit('refresh')" color="primary" class="mb-2">
        Refresh
      </v-btn>
    </h3>
    <br />
    <v-btn
      color="success"
      :loading="loading"
      :disabled="loading"
      @click="validateNID"
    >
      Verify Now
    </v-btn>
    <v-snackbar
      :color="snackbarColor"
      v-model="snackbar"
      bottom
      right
      :timeout="3000"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import { validateNIDUrl } from "@/utils/variables";
  export default {
    props: ["userID"],
    data() {
      return {
        loading: false,
        snackbar: false,
        snackbarColor: "success",
        snackbarText: "",
      };
    },
    methods: {
      async validateNID() {
        this.loading = true;
        try {
          const { data } = await HTTP().post(validateNIDUrl, {
            user_id: this.userID,
            search_type: 2,
          });
          if (data.error) {
            this.snackbar = true;
            this.snackbarColor = "error";
            this.snackbarText = data.errorMsg;
          } else {
            this.snackbar = true;
            this.snackbarColor = "success";
            this.snackbarText = data.errorMsg;
          }
        } catch (error) {
          this.snackbar = true;
          this.snackbarColor = "error";
          this.snackbarText = "Something wrong happened";
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
